import React from "react";
import Pagination from "../common/Pagination";
import TableShowLimit from "../common/TableShowLimit";
import RippleLoader from "../loader/RippleLoader";
import DataNotFound from "../common/DataNotFound";

const CustomTable = ({
  columnHeaders,
  dataRows,
  data,
  loading,
  paginationCurrentLimit,
  setPaginationCurrentLimit,
  total,
  current,
  paginationData,
  showPagination,
  overflowVisibleLg,
  shadowShow,
  backgroundColor,
  lastPage,
}) => {
  return (
    <div className="w-full rounded-lg">
      {loading ? (
        <RippleLoader />
      ) : (
        <>
          {data?.data?.length || data?.length > 0 ? (
            <div
              className={`rounded-lg ${
                overflowVisibleLg ? "lg:overflow-visible" : "overflow-x-auto"
              } ${backgroundColor ? "bg-bgGrey" : "bg-white"}`}
            >
              <table className="w-full sm:text-sm text-xs table-auto sm:table-fixed">
                {/* Table Header */}
                <thead className="sm:text-sm text-xs text-primaryBlack bg-bgLightTheme font-normal text-start">
                  <tr>{columnHeaders}</tr>
                </thead>

                {/* Table Body */}
                <tbody className="sm:text-sm text-xs font-normal">
                  {dataRows}
                </tbody>
              </table>
            </div>
          ) : (
            <DataNotFound />
          )}

          {/* Pagination */}
          {showPagination && (
            <div className="flex flex-wrap items-center justify-between sm:justify-end my-2">
              <TableShowLimit
                paginationCurrentLimit={paginationCurrentLimit}
                setPaginationCurrentLimit={setPaginationCurrentLimit}
              />
              <p className="text-xs font-Proxima pl-2">
                {`${(data?.current_page - 1) * data?.per_page + 1} - ${
                  (data?.current_page - 1) * data?.per_page + data?.data?.length
                } of ${total}`}
              </p>
              <div className="px-4 py-2 rounded-lg">
                <Pagination
                  total={total}
                  lastPage={lastPage}
                  current={current}
                  pagination={paginationData}
                />
              </div>
            </div>
          )}
        </>
      )}
    </div>
  );
};

export default CustomTable;
